/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCardMastercardLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 20"
    {...props}
  >
    <path fill="#FF5F00" d="M19.247 4.184H12.76v11.63h6.488V4.183Z" />
    <path
      fill="#EB001B"
      d="M13.171 9.998c0-2.26 1.05-4.417 2.822-5.814C12.78 1.657 8.104 2.21 5.57 5.437c-2.513 3.205-1.957 7.849 1.277 10.376a7.41 7.41 0 0 0 9.165 0 7.393 7.393 0 0 1-2.842-5.815Z"
    />
    <path
      fill="#F79E1B"
      d="M28 9.998c0 4.089-3.316 7.397-7.415 7.397a7.35 7.35 0 0 1-4.572-1.582 7.397 7.397 0 0 0 1.235-10.396 7.786 7.786 0 0 0-1.235-1.233c3.213-2.527 7.888-1.973 10.4 1.253A7.31 7.31 0 0 1 28 9.998Z"
    />
  </svg>
);

export default SvgCardMastercardLogo;
